module.exports = __webpack_public_path__ + "img/302.59c64fa1.svg";